import { useState } from "react";
import Alert from "components/common/Alert";
import ExhibitorCategoryForm from "./ExhibitorCategoryForm";

export default function ExhibitorCategoryModal({
  initialData,
  onSubmit,
  onClose,
}) {
  const [modalError, setModalError] = useState("");

  return (
    <div className="p-6">
      {modalError && (
        <Alert
          type="error"
          message={modalError}
          onClose={() => setModalError("")}
        />
      )}

      <ExhibitorCategoryForm
        initialData={initialData}
        onClose={onClose}
        onSubmit={(payload) => onSubmit(payload, setModalError)}
      />
    </div>
  );
}
